import { useNavigation } from "@react-navigation/native"
import { StackNavigationProp } from "@react-navigation/stack"
import { auth, FormikTextInput, useAlert, useTheme } from "capsule"
import { InputScreen } from "capsule/components/Screens/InputScreen"
import { FormikConfig } from "formik"
import React, { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { StyleSheet, View } from "react-native"
import { Text } from "react-native-paper"
import * as Yup from "yup"

import { INPUT_HEIGHT } from "../../features/config/Constants"
import { LoginNS } from "../../features/i18n/constants"
import { RootParamList } from "../../features/Navigation/types"

export interface LoginFormValues {
  email: string
  password: string
}

const MfaRegisterScreen = () => {
  const {
    dimensions: { spacing },
    colors: {
      surface: { background, textInput },
    },
  } = useTheme()
  const navigation = useNavigation<StackNavigationProp<RootParamList, "Mfa">>()
  const { showSnack } = useAlert()
  const [loading, setLoading] = useState(false)

  const { t } = useTranslation(LoginNS)
  const handleSubmit = async ({ email, password }: LoginFormValues) => {
    setLoading(true)
    try {
      await auth().signInWithEmailAndPassword(email, password)
      navigation.navigate("Mfa")
    } catch (error) {
      switch (error.code) {
        case "auth/wrong-password":
        case "auth/user-not-found":
          showSnack({ message: t("errors.invalidCredentials") })
          break
        default:
          showSnack({ message: t("errors.unknown") })
      }
      setLoading(false)
    }
  }
  const formikConfig: FormikConfig<LoginFormValues> = {
    validateOnMount: true,
    onSubmit: handleSubmit,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email().required(t("errors.emailNeeded")),
      password: Yup.string().required(t("errors.passwordNeeded")),
    }),
  }
  const { inputStyle, view } = useMemo(
    () => ({
      inputStyle: { backgroundColor: textInput, marginBottom: spacing, minHeight: INPUT_HEIGHT },
      view: [styles.view, { backgroundColor: background, paddingHorizontal: spacing }],
    }),
    [spacing, textInput, background],
  )

  return (
    <View style={view}>
      <Text>{t("disconnected")}</Text>
      <Text>{t("pleaseSignUp")}</Text>
      <InputScreen<LoginFormValues>
        formLoading={!loading}
        Inputs={
          <View>
            <FormikTextInput
              name="email"
              changeUnderline={false}
              label={t("email")}
              style={inputStyle}
            />
            <FormikTextInput
              name="password"
              secureTextEntry
              changeUnderline={false}
              autoCapitalize="none"
              autoComplete="off"
              autoCorrect={false}
              label={t("password")}
              style={inputStyle}
            />
          </View>
        }
        buttonLabel={t("signUpButton")}
        formikConfig={formikConfig}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  view: {
    flex: 1,
  },
})

export default MfaRegisterScreen
